module.exports = new __parcel__URL__("ai-enable-banner-org-admin.1ceaac44.svg").toString();